import axios from "axios";

export const SELECCIONAR_EMPRESA = 'SELECCIONAR_EMPRESA'

export const DESELECCIONAR_EMPRESA = 'DESELECCIONAR_EMPRESA'

export const CONTAR_VENTAS_PENDIENTES = 'CONTAR_VENTAS_PENDIENTES'

export const CONTAR_SUGERENCIAS_PENDIENTES = 'CONTAR_SUGERENCIAS_PENDIENTES'

export const CONTAR_EVALUACIONES_PROVEEDOR_PENDIENTES = 'CONTAR_EVALUACIONES_PROVEEDOR_PENDIENTES'

export const CAMBIAR_IMPRESORA = 'CAMBIAR_IMPRESORA'

export const seleccionarEmpresa = (data) => {
    return async (dispatch) => {
        return axios
          .post("empresas/seleccionarEmpresa", data)
          .then((res) => {
            if (res.data.success === 1) {
              dispatch({ type: SELECCIONAR_EMPRESA, data })   
              return {success: 1};
            } else {
              return {success: 0, err: "No se pudo seleccionar la empresa"};
            }
          })
          .catch((err) => {
            throw new Error(err.message);
          });
      };
}

export const seleccionarEmpresaHasSigned = (data) => {
    return async (dispacth) => {
        return dispacth({ type: SELECCIONAR_EMPRESA, data})
    }
}

export const deseleccionarEmpresa = () => {
    return async (dispacth) => {
        return dispacth({ type: DESELECCIONAR_EMPRESA})
    }
}

export const contarVentasPPendientes = (data) => {
  return async (dispatch) => {
      return axios
        .post("ventasProgramadas/contarPendientes", data)
        .then((res) => {
          if (res.data.success === 2) {
            dispatch({ type: CONTAR_VENTAS_PENDIENTES, data: res.data })   
            return {success: 2};
          } else {
            return {success: 0, err: "No se pudo consultar el conteo de ventas pendientes"};
          }
        })
        .catch((err) => {
          throw new Error(err.message);
        });
    };
}

export const contarEvaluacionesProveedorPendientes = (data) => {
  return async (dispatch) => {
      return axios
        .post("evaluacionesProveedor/contarPendientes", data)
        .then((res) => {
          if (res.data.success === 2) {
            dispatch({ type: CONTAR_EVALUACIONES_PROVEEDOR_PENDIENTES, data: res.data })
            return {success: 2};
          } else {
            return {success: 0, err: "No se pudo consultar el conteo de evaluaciones pendientes"};
          }
        })
        .catch((err) => {
          throw new Error(err.message);
        });
    };
}

export const contarSugerenciasPendientes = (data) => {
  return async (dispatch) => {
      return axios
        .post("sugerenciasRequisicion/contarPendientes", data)
        .then((res) => {
          if (res.data.success === 2) {
            dispatch({ type: CONTAR_SUGERENCIAS_PENDIENTES, data: res.data })
            return {success: 2};
          } else {
            return {success: 0, err: "No se pudo consultar el conteo de sugerencias pendientes"};
          }
        })
        .catch((err) => {
          throw new Error(err.message);
        });
    };
}

export const cambiarImpresora = (data) => {
    return async (dispatch) => {
        return dispatch({ type: CAMBIAR_IMPRESORA, data })
    }
}